export const ACTIVE = 'Active';
export const OFFBOARDED = 'Offboarded';

export const ContractorStatus = [ACTIVE, OFFBOARDED];

export const HMVPActiveContractorStatus = [ACTIVE];
